import Api from "../../apiService";

class telemetryTrackersApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/trackers`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, trackerId) {
    return Api.getRequest(
      `companies/${companyId}/telemetry/trackers/${trackerId}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/telemetry/trackers`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, trackerId, data) {
    return Api.patchRequest(
      `companies/${companyId}/telemetry/trackers/${trackerId}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, trackerId) {
    return Api.patchRequest(
      `companies/${companyId}/telemetry/trackers/${trackerId}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, trackerId) {
    return Api.patchRequest(
      `companies/${companyId}/telemetry/trackers/${trackerId}/disable`,
      {},
      Api.authHeaders()
    );
  }

  setPrimary(companyId, trackerId) {
    return Api.postRequest(
      `companies/${companyId}/telemetry/trackers/${trackerId}/set_primary`,
      {},
      Api.authHeaders()
    );
  }
}

export default new telemetryTrackersApi();
